"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    buttonDisabled: false,
    buttonVariant: 'contained',
    disabled: false,
    loading: false,
    onClickBack: function () {
        // do nothing
    },
    onClickContinue: function () {
        // do nothing
    },
    textOverflowHandling: 'none',
    continueButtonHidden: false,
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map